import { Auth0Provider } from '@auth0/auth0-react';
import { PropsWithChildren } from 'react';
import { apiClient } from '../../services/api-client.service';
import ErrorFallback from '../common/ErrorFallback';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { getConfig } from '../../config';
import { setSentryUser, clearSentryUser } from '../../services/sentry.service';

const { auth0 } = getConfig();

const AuthTokenSetter = () => {
  const { isAuthenticated, getAccessTokenSilently, user } = useAuth0();

  useEffect(() => {
    const setToken = async () => {
      if (isAuthenticated) {
        const token = await getAccessTokenSilently();
        apiClient.setBearerToken(token);

        // Set user context in Sentry
        if (user) {
          setSentryUser({
            id: user.sub,
            email: user.email,
            username: user.nickname || user.name,
          });
        }
      } else {
        apiClient.setBearerToken(null);
        // Clear user context in Sentry
        clearSentryUser();
      }
    };
    setToken();
  }, [isAuthenticated, getAccessTokenSilently, user]);

  return null;
};

export const AuthProvider = ({ children }: PropsWithChildren) => {
  if (!auth0.domain || !auth0.clientId) {
    return (
      <ErrorFallback
        error={new Error('Auth0 configuration is missing')}
        resetErrorBoundary={() => {}}
      />
    );
  }

  return (
    <Auth0Provider
      domain={auth0.domain}
      clientId={auth0.clientId}
      authorizationParams={{
        redirect_uri: auth0.redirectUri,
        audience: auth0.audience,
      }}
      cacheLocation="localstorage"
    >
      <AuthTokenSetter />
      {children}
    </Auth0Provider>
  );
};
